import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

// VerbalYesForm — includes the "Create draft invoice now" checkbox per
// item 1.6. Sprint B persists the flag in structured_payload; Sprint E
// completes the actual invoice creation transaction.
export default function VerbalYesForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('verbal_yes')} values={values} onChange={onChange} errors={errors} />;
}
